import { Fieldset, Radio, ValidationMessage } from '@digdir/designsystemet-react';
import { FieldError, FieldPath, useFormContext } from 'react-hook-form';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { SolcellerFormData } from '../../types';

interface Props {
  fieldPath: FieldPath<SolcellerFormData>;
  error?: FieldError;
}

export const PanelTypeRadio: FC<Props> = ({ fieldPath, error }) => {
  const { t } = useTranslation();
  const { register } = useFormContext<SolcellerFormData>();

  return (
    <Fieldset>
      <Fieldset.Legend>{t('register.solar.form.panel.type')}</Fieldset.Legend>
      <Radio
        {...register(fieldPath, { required: t('register.solar.form.panel.type.missing') })}
        label={t('register.solar.form.panel.type.panel')}
        value="solcellepanel"
      />
      <Radio
        {...register(fieldPath, { required: t('register.solar.form.panel.type.missing') })}
        label={t('register.solar.form.panel.type.other')}
        value="solcelletakstein"
      />
      {error && <ValidationMessage data-color="danger">{error?.message}</ValidationMessage>}
    </Fieldset>
  );
};
